import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetches a hub image via authenticated endpoint and renders as a blob URL.
 * <img> cannot carry Authorization/cookies, so we fetch-as-blob.
 */
export default function HubImage({ imageKey, alt = "", className = "" }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const objectUrl = useRef(null);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            try {
                const response = await axios.get(`${API}/hub/files/${imageKey}`, {
                    responseType: "blob",
                    withCredentials: true,
                });
                if (cancelled) return;
                const url = URL.createObjectURL(response.data);
                objectUrl.current = url;
                setBlobUrl(url);
            } catch (e) {
                // silent
            }
        }
        if (imageKey) load();
        return () => {
            cancelled = true;
            if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
        };
    }, [imageKey]);

    if (!blobUrl) {
        return <div className={`${className} bg-sanct-clay/40 animate-pulse`} />;
    }
    return <img src={blobUrl} alt={alt} className={className} />;
}
